document.addEventListener('DOMContentLoaded', function () {
  const nameInput = document.getElementById('CustomContactForm-name');
  const nameField = nameInput.closest('.custom-contact-form__field');
  const emailInput = document.getElementById('CustomContactForm-email');
  const emailField = emailInput.closest('.custom-contact-form__field');
  const phoneInput = document.getElementById('CustomContactForm-phone');
  const phoneField = phoneInput.closest('.custom-contact-form__field');
  const submitBtn = document.querySelector('.custom-contact-form__submit');

  function ensureErrorEl(field) {
    let el = field.querySelector('.custom-contact-form__field-error');
    if (!el) {
      el = document.createElement('div');
      el.className = 'custom-contact-form__field-error';
      el.style.display = 'none';
      field.appendChild(el);
    }
    return el;
  }
  let nameErrorEl = ensureErrorEl(nameField);
  let emailErrorEl = ensureErrorEl(emailField);
  let phoneErrorEl = ensureErrorEl(phoneField);

  const errorIconField = `
    <span class="svg-wrapper" data-error-icon>
      <svg width="24" height="24" viewBox="0 0 24 24" fill="none" xmlns="http://www.w3.org/2000/svg">
        <path d="M12 16V12M12 8H12.01M22 12C22 17.5228 17.5228 22 12 22C6.47715 22 2 17.5228 2 12C2 6.47715 6.47715 2 12 2C17.5228 2 22 6.47715 22 12Z" stroke="#DD272A" stroke-width="1.15" stroke-linecap="round" stroke-linejoin="round"/>
      </svg>
    </span>
  `;

  function setFieldIcon(field, input, show) {
    let icon = field.querySelector('.svg-wrapper[data-error-icon]');
    if (show) {
      if (!icon) {
        input.insertAdjacentHTML('afterend', errorIconField);
      }
    } else {
      if (icon) icon.remove();
    }
  }

  function validateName(value) {
    return /^[A-Za-zА-Яа-яЁё\s]{2,}$/.test(value.trim());
  }

  function validateEmail(value) {
    return /^[^\s@]+@[^\s@]+\.[^\s@]+$/.test(value.trim());
  }

  function validatePhone(value) {
    return /^[\d\s\-()+]{6,}$/.test(value.trim());
  }

  let nameDirty = false;
  let emailDirty = false;
  let phoneDirty = false;

  function updateValidation() {
    let nameValid = validateName(nameInput.value);
    let emailValid = validateEmail(emailInput.value);
    let phoneValid = validatePhone(phoneInput.value);

    if (!nameValid && nameDirty) {
      nameInput.setAttribute('aria-invalid', 'true');
      nameField.classList.add('custom-contact-form__field--with-error');
      nameErrorEl.textContent = 'Invalid Name';
      nameErrorEl.style.display = 'flex';
      setFieldIcon(nameField, nameInput, true);
    } else {
      nameInput.removeAttribute('aria-invalid');
      nameField.classList.remove('custom-contact-form__field--with-error');
      nameErrorEl.textContent = '';
      nameErrorEl.style.display = 'none';
      setFieldIcon(nameField, nameInput, false);
    }

    if (!emailValid && emailDirty) {
      emailInput.setAttribute('aria-invalid', 'true');
      emailField.classList.add('custom-contact-form__field--with-error');
      emailErrorEl.textContent = 'Invalid Email';
      emailErrorEl.style.display = 'flex';
      setFieldIcon(emailField, emailInput, true);
    } else {
      emailInput.removeAttribute('aria-invalid');
      emailField.classList.remove('custom-contact-form__field--with-error');
      emailErrorEl.textContent = '';
      emailErrorEl.style.display = 'none';
      setFieldIcon(emailField, emailInput, false);
    }

    if (!phoneValid && phoneDirty) {
      phoneInput.setAttribute('aria-invalid', 'true');
      phoneField.classList.add('custom-contact-form__field--with-error');
      phoneErrorEl.textContent = 'Invalid Phone';
      phoneErrorEl.style.display = 'flex';
      setFieldIcon(phoneField, phoneInput, true);
    } else {
      phoneInput.removeAttribute('aria-invalid');
      phoneField.classList.remove('custom-contact-form__field--with-error');
      phoneErrorEl.textContent = '';
      phoneErrorEl.style.display = 'none';
      setFieldIcon(phoneField, phoneInput, false);
    }

    submitBtn.disabled = !(nameValid && emailValid && phoneValid);
  }

  nameInput.addEventListener('input', function () {
    nameDirty = true;
    updateValidation();
  });
  nameInput.addEventListener('change', function () {
    nameDirty = true;
    updateValidation();
  });
  emailInput.addEventListener('input', function () {
    emailDirty = true;
    updateValidation();
  });
  emailInput.addEventListener('change', function () {
    emailDirty = true;
    updateValidation();
  });
  phoneInput.addEventListener('input', function () {
    phoneDirty = true;
    updateValidation();
  });
  phoneInput.addEventListener('change', function () {
    phoneDirty = true;
    updateValidation();
  });

  submitBtn.disabled = true;

  updateValidation();

  // Функция для добавления/удаления класса is-filled
  function updateFilledState(input) {
    if (input.value.trim() !== '') {
      input.classList.add('is-filled');
    } else {
      input.classList.remove('is-filled');
    }
  }

  // Для всех инпутов формы:
  document.querySelectorAll('.custom-contact-form__input').forEach(input => {
    input.addEventListener('input', () => updateFilledState(input));
    // Проверить при загрузке (например, автозаполнение браузером)
    updateFilledState(input);
  });
}); 